import PropTypes from 'prop-types';

export const TableActionShape = PropTypes.shape({
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
});
